import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { useSearchParams } from 'react-router';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { ANY_SPORT_MARKET_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useDeeplinkFromNativeApp } from '@sorare/core/src/hooks/useDeeplinkFromNativeApp';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { useMarketplaceEvents } from 'lib/events';

import { InfoIconTutorial } from '../InfoIconTutorial';
import { MarketVideoDialog } from '../MarketVideoDialog';
import { NewNavDialog } from '../NewNavDialog';

type Props = { isOnboardingFlow?: boolean; isNewNavigation?: boolean };
export const MarketVideoTutorial = ({
  isOnboardingFlow = false,
  isNewNavigation = false,
}: Props) => {
  const [open, setOpen] = useState(isOnboardingFlow);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showIconTutorial, setShowIconTutorial] = useState(false);
  const [sawDialog, setSawDialog] = useState(false);
  const [newNavDialogOpen, setNewNavDialogOpen] = useState(false);
  const track = useMarketplaceEvents();
  const { isIosApp } = useIsMobileApp();
  const { navigateWithDeeplink } = useDeeplinkFromNativeApp();

  const onCloseDialog = () => {
    setOpen(false);
    if (isOnboardingFlow && !sawDialog) {
      if (isNewNavigation) {
        setNewNavDialogOpen(true);
      } else if (isIosApp) {
        navigateWithDeeplink(
          generateSportPath(ANY_SPORT_MARKET_INSTANT_BUY, {
            sport: Sport.FOOTBALL,
          })
        );
      } else {
        setShowIconTutorial(true);
      }
    }
    setSawDialog(true);
  };

  return (
    <>
      <OnboardingHighlightWrapper
        wrap={isOnboardingFlow}
        highlightName="MarketInfoIcon"
      >
        <IconButton
          color="quaternary"
          size="small"
          onClick={() => {
            track('Open Video Tutorial On Marketplace');
            setOpen(true);
          }}
          icon={faInfoCircle}
        />
      </OnboardingHighlightWrapper>
      <MarketVideoDialog
        data-testid="market-video-dialog"
        open={open}
        onClose={onCloseDialog}
        showOnboardingElements={!!isOnboardingFlow && !sawDialog}
      />
      <NewNavDialog
        open={newNavDialogOpen}
        onClose={() => {
          setNewNavDialogOpen(false);
          setShowIconTutorial(true);
        }}
      />
      {!!showIconTutorial && (
        <InfoIconTutorial
          onClose={() => {
            setShowIconTutorial(false);
            searchParams.delete('isOnboardingFlow');
            setSearchParams(searchParams);
          }}
        />
      )}
    </>
  );
};
